import { InquiryOfferState } from '@synergy/models';
import { LegacyDateRangeFilter } from '@synergy/components';
import { PaloFilterModal } from '@synergy/components-palo';
import { ReactElement } from 'react';

import { AuctionFilter } from '../../../common/components/filter/auction-filter';
import { InquiryOfferStateFilter } from '../../../common/components/filter/inquiry-offer-state-filter';

/** As the legacy filter, without its search field — the list header owns that. */
export const PaloInquiriesOverviewFilter = (): ReactElement => (
    <PaloFilterModal>
        <LegacyDateRangeFilter />
        <InquiryOfferStateFilter
            inquiryOfferStates={[
                InquiryOfferState.Open,
                InquiryOfferState.OnGoing,
                InquiryOfferState.Declined,
                InquiryOfferState.Closed,
            ]}
        />
        <AuctionFilter />
    </PaloFilterModal>
);
